import VerifyEmailPage from './VerifyEmailPage';
export default VerifyEmailPage;